/**
 * Deutsche Zahl-Eingaben ("153.740,58" | "1.234,56" | "1234.5") in Zahlen —
 * für freie Geld/Prozent-Felder in Formularen. Leer/ungültig → null.
 * DECIMAL-Werte vom API kommen als String und laufen hier NICHT durch
 * (Formatierung über formatCurrency — niemals mit Strings rechnen).
 */
export function parseGermanDecimal(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isNaN(value) ? null : value;
  const t = String(value).trim().replace(/[€\s]/g, '');
  if (t === '') return null;
  const n = parseFloat(t.replace(/\./g, '').replace(',', '.'));
  return Number.isNaN(n) ? null : n;
}

/** Zahl → Eingabe-String (de-DE-Komma) für Draft-Felder; null → "". */
export function toInputNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'number') return String(value).replace('.', ',');
  return String(value);
}